import { useRef } from 'react';

import { FormFeedback } from '@/components';
import { PLATFORM_CAPTIONS } from '@/constants';

const URLInput = ({
  url,
  source,
  caption,
  disabled,
  onUrlChange,
  requiredSource,
}) => {
  const sourceCaption = `${PLATFORM_CAPTIONS[source]} ${caption}`;

  const requiredSourceCaption = `${PLATFORM_CAPTIONS[requiredSource]} ${caption}`;

  const inputRef = useRef(null);

  const hasError =
    (url && source === null) ||
    (source && requiredSource && source !== requiredSource);

  const errorMessage = hasError
    ? source === null
      ? 'The URL is invalid or unsupported.'
      : `Expected a ${requiredSourceCaption} but got a ${sourceCaption}.`
    : null;

  const handleChange = (e) => onUrlChange(e.target.value.trim());

  const handleClick = async () => {
    if (url) {
      inputRef.current.value = '';
      onUrlChange('');
    } else {
      try {
        const text = (await navigator.clipboard.readText()).trim();

        if (!text) {
          inputRef.current?.focus();
        } else {
          inputRef.current.value = text;
          onUrlChange(text);
        }
      } catch (err) {
        console.error('Failed to read clipboard: ', err);
      }
    }
  };

  return (
    <>
      <div className="input-group">
        <input
          type="text"
          value={url}
          ref={inputRef}
          disabled={disabled}
          onChange={handleChange}
          placeholder={`Paste the ${requiredSource ? requiredSourceCaption : caption} URL here`}
          className={`form-control shadow-sm ${hasError ? 'border-danger is-invalid' : 'border'}`}
        />
        {(source === null || hasError) && (
          <button
            type="button"
            onClick={handleClick}
            className={`btn shadow-sm ${hasError ? 'btn-outline-danger' : 'border'}`}
          >
            {url ? 'Clear' : 'Paste'}
          </button>
        )}
      </div>

      {hasError && <FormFeedback type="danger">{errorMessage}</FormFeedback>}
    </>
  );
};

export default URLInput;
